import { ReactNode, useMemo } from 'react';

import Tabs from 'approot/shared/tabs/tabs';
import { useMediaQuery } from 'approot/shared/style';
import {
  LESSON_TABS,
  PREVIOUS,
  PRINTABLES,
  STIMULUS,
} from './lesson.constants';
import { useRegionData } from 'approot/shared/region/region.apollo';
import * as Styled from './lesson-action-bar.style';
import {
  EVENT_CATEGORY_LESSON_NAV,
  EVENT_TARGET_TYPE_LESSON,
} from 'approot/shared/data-tracker/data-events.constants';

type Props = {
  activeTab: string;
  actionButtons: ReactNode;
  showStimulus?: boolean;
  showPrintables?: boolean;
  showPreviousVersion?: boolean;
  onChangeTab: (value: string) => void;
  lessonId: number;
};

const LessonActionBar = ({
  activeTab,
  actionButtons,
  showStimulus,
  showPrintables,
  showPreviousVersion,
  onChangeTab,
  lessonId,
}: Props) => {
  const isMediaUpMd = useMediaQuery(
    `(min-width: ${Styled.ACTION_BAR_BREAKPOINT}px)`
  );

  const {
    regionBanner: { height },
  } = useRegionData();

  const options = useMemo(() => {
    let tabs = LESSON_TABS;
    if (!showStimulus) {
      tabs = tabs.filter(t => t.value !== STIMULUS);
    }
    if (!showPrintables) {
      tabs = tabs.filter(t => t.value !== PRINTABLES);
    }
    if (!showPreviousVersion) {
      tabs = tabs.filter(t => t.value !== PREVIOUS);
    }
    return tabs;
  }, [showPrintables, showStimulus, showPreviousVersion]);

  return (
    <>
      {!isMediaUpMd && (
        <Styled.LessonActionBarGroupWrapper>
          <Styled.LessonActionBarGroup>
            {actionButtons}
          </Styled.LessonActionBarGroup>
        </Styled.LessonActionBarGroupWrapper>
      )}
      <Styled.LessonActionBar bannerHeight={height}>
        <Styled.LessonActionBarContent>
          <Styled.LessonActionBarTabs>
            <Tabs
              activeTab={activeTab}
              options={options}
              ariaDescription="Lesson page content tabs"
              contentPanelId="lesson-content"
              onSelect={option => {
                window.scrollTo(0, 0);
                onChangeTab(option.value as string);
              }}
              dataEvent={{
                category: EVENT_CATEGORY_LESSON_NAV,
                target: {
                  target_type: EVENT_TARGET_TYPE_LESSON,
                  target_identifier: lessonId,
                },
              }}
            />
          </Styled.LessonActionBarTabs>
          {isMediaUpMd && (
            <Styled.LessonActionBarGroup>
              {actionButtons}
            </Styled.LessonActionBarGroup>
          )}
        </Styled.LessonActionBarContent>
      </Styled.LessonActionBar>
    </>
  );
};

export default LessonActionBar;
